import { Deserializable } from '../protocols/deserializable';
import { InvestmentInstruction } from './investment-instruction';

export class InvestmentInstructions implements Deserializable {
  public id!: number;
  public lastUpdatedDate!: string;
  public investmentInstructions!: InvestmentInstruction[];

  onDeserialize() {
    if (!!this.investmentInstructions) {
      this.investmentInstructions = window.injector.Deserialize.arrayOf(
        InvestmentInstruction,
        this.investmentInstructions
      );
    }
  }
}
